import { Box } from "@mui/material"
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useMainMenuContext } from "../../pages/components/MainMenu/MainMenuProvider";
import { useLocation } from "react-router";
export const ShiftContainer = ({ containerRef, children }: { containerRef: HTMLDivElement | null, children: any }) => {
    const { openMenu } = useMainMenuContext()
    const location = useLocation()
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [containerLeftShift, setContainerLeftShift] = useState(0);
    useLayoutEffect(() => {
        if (!containerRef || !wrapperRef.current) return;
        const containerLeft =
            containerRef.getBoundingClientRect().left;
        const wrapperLeft =
            wrapperRef.current.getBoundingClientRect().left;
        setContainerLeftShift(containerLeft - wrapperLeft)
        // if (!containerRef) { return; }

        // const updateContainerLeft = () => {
        //     if (containerRef.current) {
        //         setContainerLeftShift(
        //             containerRef.current.getBoundingClientRect().left
        //         );
        //     }
        // };
        // // const frame = requestAnimationFrame(updateContainerLeft);
        // // const observer = new ResizeObserver(updateContainerLeft)
        // // observer.observe(containerRef.current);
        // console.log("running this: ", containerRef.current)
        // updateContainerLeft();

        // window.addEventListener("resize", updateContainerLeft);

        // return () => {
        //     window.removeEventListener("resize", updateContainerLeft);
        // };
    }, [containerRef, location.pathname])

    const shift = Math.max(0, 250 - containerLeftShift);

    return (
        <Box
            sx={{
                width: openMenu
                    ? `calc(100% - ${shift}px)`
                    : "100%",
                // width: "100%",
                transition: theme =>
                    theme.transitions.create('margin-left', {
                        duration: theme.transitions.duration.enteringScreen,
                        easing: theme.transitions.easing.easeOut,

                    }),
                marginLeft: openMenu ? `${shift}px` : "0px"
            }}>
            {children}
        </Box>
    )
}